import React, { useEffect, useState } from 'react';
import TaskNews from '../../../../ws/TaskNews';
import { withTranslation, WithTranslation } from 'react-i18next';
import { translate } from '../../../../../I18n/i18n';
import './PopUpVideo.scss';

interface PopupVideoProps extends WithTranslation{
    show: boolean;
    onClose: () => void;
    mediaId: number;  // Propiedad para recibir el ID del video
}

const PopupVideo: React.FC<PopupVideoProps> = ({ show, onClose, mediaId, t }) => {
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const taskNews = new TaskNews();

    useEffect(() => {
        if (!show) return;  // Si el popup no debe mostrarse, no hacemos la llamada.

        document.body.style.overflow = 'hidden';

        const fetchVideo = async () => {
            try {
                setLoading(true);
                const videoUrl = await taskNews.getVideo(mediaId);
                setVideoUrl(videoUrl);
            } catch (err) {
                setError('Error al obtener el video.');
            } finally {
                setLoading(false);
            }
        };

        fetchVideo();
    }, [mediaId, show]);  // Solo ejecutar la llamada cuando el mediaId cambie o el show sea true.

    useEffect(() => {
        // Si el popup se cierra, limpiamos el videoBlob
        if (!show) {
            setVideoUrl(null);
            document.body.style.overflow = '';
        }
    }, [show]);

    if (!show) return null;  // Si no se debe mostrar, no renderizamos nada

    return (
        <div className="popupVideo">
            <div className="popupVideo-overlay" onClick={onClose}></div>
            <div className="popupVideo-content">
                <div className="popupVideo-header">
                    {videoUrl &&
                        <button onClick={onClose} className="popupVideo-close-btn">
                            <i className="fas fa-times"></i>
                        </button>
                    }

                </div>
                <div className="popupVideo-body">
                    {loading && <div style={{ color: '#fff' }}>{translate(t, 'news.TR_LOADING_LABEL')}</div>}
                    {error && <div>{error}</div>}
                    {videoUrl && (
                        <video controls autoPlay>
                            <source src={videoUrl} type="video/mp4" />
                            {translate(t, 'news.TR_NOT_SUPPORTED_VIDEO_LABEL')}
                        </video>
                    )}
                </div>
            </div>
        </div>
    );
};

export default withTranslation()(PopupVideo);
